import { useEffect } from "react";
import useLeaflet from "../../hooks/useLeaflet";

const L: any = require("leaflet");
L.esri = require("esri-leaflet");

/*
 ** This component displays the streetmap tilelayer
 */

const StreetMap = () => {
  const context = useLeaflet();

  useEffect(() => {
    if (!context) return;

    const streetmap = L.tileLayer(
      "https://server.arcgisonline.com/ArcGIS/rest/services/World_Street_Map/MapServer/tile/{z}/{y}/{x}",
      {
        maxZoom: 18,
      }
    );

    context.map.addLayer(streetmap);

    return () => context.map.removeLayer(streetmap);
  }, [context]);

  //"https://mt1.google.com/vt/lyrs=h&x={x}&y={y}&z={z}"

  return null;
};

export default StreetMap;
